import { kycDocumentTypesByCategory } from '@shinetools/kyc-validation';

import { KycReviewDocumentType } from '__generated__/GQL';

export const SELF_HOSTED_DOCUMENT_TYPE = KycReviewDocumentType.ProofOfAddress;

export const ADDRESS_DOCUMENT_TYPES =
  kycDocumentTypesByCategory.ADDRESS as KycReviewDocumentType[];

export enum AccommodationStatus {
  HOSTED = 'HOSTED',
  SELF_HOSTED = 'SELF_HOSTED',
}
